module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("物流信息")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "4vw",
      "margin-top": "5vw"
    }
  }, [_c('svg', {
    attrs: {
      "width": "12px",
      "height": "17px",
      "viewBox": "0 0 12 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("形状")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "执行中订单详情",
      "transform": "translate(-25.000000, -118.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "地点",
      "transform": "translate(25.000000, 118.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.99998382,0 C2.68650826,0 0,2.76794957 0,6.18183182 C0,11.2045379 5.99998382,17 5.99998382,17 C5.99998382,17 12,11.2045712 12,6.18183182 C12,2.76794957 9.31350792,0 5.99998382,0 Z M5.99998382,9.27270606 C4.34252624,9.27270606 3,7.88874794 3,6.18181515 C3,4.47488236 4.34251007,3.09090758 5.99998382,3.09090758 C7.65676205,3.09090758 8.99998382,4.47488236 8.99998382,6.18181515 C8.99998382,7.88873128 7.6567297,9.27270606 5.99998382,9.27270606 Z",
      "id": "形状"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "3vw",
      "margin-top": "7vw"
    }
  }, [_c('span', {
    staticClass: "phone",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressMobile))]), _vm._v(" "), _c('span', {
    staticClass: "luWei",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressContactor))]), _vm._v(" "), _c('span', {
    staticClass: "summary",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('span', {
    staticClass: "expressInformation",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("快递信息")]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "expressCompany",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("快递公司")]), _vm._v(" "), _c('span', {
    staticClass: "zhongtongExpress",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressCompanyName))])]), _vm._v(" "), _c('div', {
    staticClass: "div"
  }), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [_c('span', {
    staticClass: "expressNumber",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("快递单号")]), _vm._v(" "), _c('div', {
    staticClass: "group_2",
    attrs: {
      "id": "tag-copy",
      "data-clipboard-text": _vm.expressInfo.expressNo
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "num",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressNo))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "empty_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "block_3"
  }, [_c('span', {
    staticClass: "sendStatus",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("寄/发送状态")]), _vm._v(" "), _c('span', {
    staticClass: "sent",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.sendStatusName))])]), _vm._v(" "), _c('div', {
    staticClass: "div_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_3"
  }, [_c('span', {
    staticClass: "sender",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("寄/发送人")]), _vm._v(" "), _c('span', {
    staticClass: "human",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.receiver))])]), _vm._v(" "), _c('div', {
    staticClass: "empty_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "container_3"
  }, [_c('span', {
    staticClass: "sendingTime",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("寄/发送时间")]), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.sendDTString))])]), _vm._v(" "), _c('div', {
    staticClass: "div_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "block_4"
  }, [_c('span', {
    staticClass: "signReceiveStatus",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("签/接收状态")]), _vm._v(" "), _c('span', {
    staticClass: "signed",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.receiveStatusName))])]), _vm._v(" "), _c('div', {
    staticClass: "empty_4"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "signingRecipient",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("签/接收人")]), _vm._v(" "), _c('span', {
    staticClass: "human_2",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.receiveStatusName))])]), _vm._v(" "), _c('div', {
    staticClass: "div_4"
  }), _vm._v(" "), _c('div', {
    staticClass: "container_4"
  }, [_c('span', {
    staticClass: "signReceiveTime",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("签/接收时间")]), _vm._v(" "), _c('span', {
    staticClass: "text_2",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.receiveDTString))])])]), _vm._v(" "), _c('div', {
    staticClass: "ft"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("复制")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af38ad08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupProgress/ExpressInfo.vue
// module id = 1709
// module chunks = 8